module.exports = __webpack_public_path__ + "static/media/negar.6d990473.jpeg";